<template>
  <div id="app">
    <div id="top">
      <md-app md-waterfall md-mode="fixed">
        <md-app-toolbar class="md-large md-dense md-primary main-bg">
          <Header
            @changeMenuVisible="changeMenuVisible"
            @changeLanguage="changeLanguage"
            @setShowPerson="setShowPerson"
            :isPersonOnmouse="isPersonOnmouse"
            :routeName="routeName"
          />
        </md-app-toolbar>
      </md-app>
    </div>

    <div class="main-content">
      <div class="order-sticky-scroll">
        <!--<Navi class="order-sticky pt-3" tabId="1"/>-->
      </div>
      <div v-if="isSpiner" class="text-center md-overlay md-fixed">
        <div class="spiner spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div
        v-if="isInvisibleFilter"
        class="text-center md-overlay filter-bg md-fixed"
      />
      <md-app>
        <md-app-content>
          <router-view />
        </md-app-content>
        <md-app-drawer
          :class="['w-50 d-none', { 'd-block': menuVisible2 }]"
          :md-active.sync="menuVisible"
          :md-right="true"
          @md-closed="setMenuVisible2"
          style="overflow: visible"
        >
          <Sidebar @changeMenuVisible="changeMenuVisible" />
        </md-app-drawer>
      </md-app>
      <Footer v-if="!isLogoOnly" :isLowHeight="isLowHeight" />

      <!-- サイドボタン -->
      <div class="side-button">
        <a v-scroll-to="'#top'">
          <img :src="topBtnImg" />
        </a>
      </div>
    </div>

    <!-- ユーザーアイコンにマウスオーバーした際に表示するやつ -->
    <section
      v-if="showPersonFlg"
      id="header-person"
      :style="presonStyle"
      @mouseover="isPersonOnmouse = true"
      @mouseleave="
        showPersonFlg = false
        isPersonOnmouse = false
      "
    >
      <div class="p-2">
        <table class="table bg-white">
          <tr>
            <th>ID</th>
            <td>{{ userId }}</td>
          </tr>
          <tr>
            <th>会社名</th>
            <td>{{ companyName }}</td>
          </tr>
          <tr>
            <th>お名前</th>
            <td>{{ userName }}</td>
          </tr>
          <tr>
            <th>
              メール
              <br />
              アドレス
            </th>
            <td>{{ email }}</td>
          </tr>
        </table>
        <div class="text-right mr-2 mt-1">
          <b-link v-if="!isAdmin" @click="clickEditLink()">編集</b-link>
          <b-link @click="_logout" class="ml-4">ログアウト</b-link>
        </div>
      </div>
    </section>

    <!-- 下からにゅっと出るやつ(発注車両リスト) -->
    <SyaryoList />

    <div class="text-right my-2 mr-3">
      <md-dialog-alert
        class="new"
        :md-fullscreen="false"
        @md-opened="scroll('locked')"
        @md-closed="scroll('clear')"
        :md-active.sync="isDeleted"
        md-content="<strong>アカウントを削除しました。</strong>"
      />
    </div>

    <Alert />
    <Info />
  </div>
</template>

<script>
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Messages from '@/assets/messages.json'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Sidebar from '@/components/Sidebar'
import Mixin from '@/components/mixin/Mixin'
import Navi from '@/components/order/Navi'
import Alert from '@/components/Alert'
import Info from '@/components/Info'
import SyaryoList from '@/components/SyaryoList'
import Constant from '@/const'
import Store from '@/store/index.js'
// 言語の設定
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ja', // デフォルト言語
  messages: Messages,
})
const MOBILE_SCREEN_WIDTH = 768
const TABLET_SCREEN_WIDTH = 992
const HEIGHT_LIMIT = 550 // 端末高さのshort / lognの閾値
export default {
  name: 'App',
  i18n,
  components: {
    Navi,
    Header,
    Footer,
    Sidebar,
    Alert,
    Info,
    SyaryoList,
  },
  mixins: [Mixin],
  data: () => ({
    isLowHeight: false,
    isDeleted: false,
    topBtnImg: require('./assets/img/top-btn.png'),
    menuVisible: false,
    menuVisible2: false,
    showPersonFlg: false,
    isPersonOnmouse: false,
    presonStyle: {
      right: null,
    },
    routeName: '',
  }),
  methods: {
    clickEditLink() {
      this.showPersonFlg = false
      this.isPersonOnmouse = false
      this.setSettingMyData()
      this.$router.push({ name: 'SettingEdit' })
    },
    async setMenuVisible2() {
      // await this.sleep(150)
      this.menuVisible2 = false
    },
    _logout() {
      this.showPersonFlg = false
      this.isPersonOnmouse = false
      this.logout()
    },
    // 言語切り替え
    changeLanguage() {
      Store.commit('user/changeLanguage')
      const lang = Store.state.user.lang
      this.$i18n.locale = lang
    },
    // ヘッダメニューの表示切設定
    changeMenuVisible() {
      this.menuVisible = !this.menuVisible
      if (this.menuVisible2) {
        this.setMenuVisible2()
      } else {
        this.menuVisible2 = !this.menuVisible2
      }
    },
    handleResize() {
      /// resizeのたびにこいつが発火するので、ここでやりたいことをやる ////

      // スクリーンサイズから端末判定（レスポンシブ用の区分のため、実際の端末と違っても問題ない）
      let mobile = Constant.MOBILE.PC
      const windowWidth = window.innerWidth
      if (
        MOBILE_SCREEN_WIDTH <= windowWidth &&
        windowWidth < TABLET_SCREEN_WIDTH
      ) {
        mobile = Constant.MOBILE.TABLET
      } else if (windowWidth < MOBILE_SCREEN_WIDTH) {
        mobile = Constant.MOBILE.SP
      }
      if (Store.state.screen.type !== mobile) {
        const data = {
          type: mobile,
          hType: window.innerHeight > HEIGHT_LIMIT ? 'long' : 'short',
        }
        Store.commit('screen/create', data)
      }
      Store.commit('screen/create', {
        width: window.innerWidth,
        height: window.innerHeight,
      })

      // ユーザーアイコン表示関連
      this.setPersonRightX()
    },
    // ユーザーアイコンのオンマウス時に表示するブロックの表示設定
    setShowPerson(flg) {
      this.showPersonFlg = flg
    },
    // ユーザーアイコンのオンマウス時に表示するブロックの位置を設定
    setPersonRightX() {
      const windowWidth = window.innerWidth
      const diff = 1280 - windowWidth
      let right = 0
      if (diff < 0) {
        right = (diff / 2) * -1 + right
      }
      this.presonStyle.right = `${right}px`
    },
  },
  computed: {
    isSpiner() {
      return this.isSpinerDisplay()
    },
    isInvisibleFilter() {
      return this.isInvisibleFilterDisplay()
    },
    userId() {
      return Store.state.user.data.USER_ID
    },
    userName() {
      return (
        (Store.state.user.data.TANTO_MEI_SEI || '') +
        (Store.state.user.data.TANTO_MEI || '')
      )
    },
    companyName() {
      return this.isAdmin
        ? '株式会社ロジコ'
        : Store.state.user.data.hum_torihiki.SOFU_SAKI_MEI
    },
    email() {
      return Store.state.user.data.MAIL_ADDR
    },
  },
  watch: {
    // 画面遷移の際にコールされる
    $route: function (to, from) {
      Store.dispatch('setting/checkVersion')

      this.routeName = to.name
      let flg = false
      if (to.path === '/logout') {
        return this.logout()
      }
      if (to.path === '/order') {
        Store.commit('vehicle/destroy')
        Store.commit('order/destroyOrder')
      }
      if (to.path === '/order/vehicle' || to.path === '/order/meihen/vehicle') {
        flg = true
      }
      if (!(to.name === 'HistoryIndex' || to.name === 'HistoryDetail')) {
        Store.commit('history/destroy')
      }
      if (to.name === 'SettingIndex') {
        this.isLowHeight = true
      } else {
        this.isLowHeight = false
      }
      Store.commit('vehicle/changeDisplayButtomElem', flg)
    },
  },
  mounted: function () {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  created: function () {
    Store.commit('vehicle/destroy') // 車両リストを初期化
    Store.commit('order/destroyOrder') // 車両リストを初期化
    this.setPersonRightX()

    // 言語設定
    const lang = Store.state.user.lang
    if (lang) {
      this.$i18n.locale = lang
    }
    // ボトム要素表示設定
    Store.commit('vehicle/changeDisplayButtomElem', false)

    // 画面情報を初期化
    Store.commit('screen/destroy')

    if (this.$router.history.current.name === 'SettingIndex') {
      this.isLowHeight = true
    }
  },
}
</script>

<style lang="sass" scoped>
@import './assets/css/logico2'
.filter-bg
  background: rgba(0,0,0,0)
  z-index: 1000
.side-button
  position: fixed
  z-index: 2
  bottom: 20px
  right: 0px
  img
    width: 40%
    &:hover
      opacity: 0.8
    cursor: pointer
  a
    color: $baseGreenColor !important
  @include sp
    right: -40px

.order-sticky-scroll
  @extend .sticky-scroll
  .order-sticky
    @extend .sticky
    top: 10px

section#header-person
  border: 3px solid $baseBlackColor !important
  width: $baseWidth * 0.3
  background-color: $baseGrayColor
  position: fixed
  top: 60px
  z-index: 11
  border-radius: 2px
  th
    width: 30%
.spiner
  margin-top: 350px
  color: white
.next-btn
  @include sp
    height: 35px
.md-overlay
  z-index: 20
</style>



// WEBPACK FOOTER //
// src/App.vue